<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>

    <section>
      <b-table
        :data="data"
        :hoverable="true"
        :striped="true"
        :row-class="rowClass"
        :mobile-cards="true"
        :loading="isLoading"
        @click="view"
        default-sort="id"
        sort-icon="sort-up"
      >
        <template slot-scope="props">
          <b-table-column field="title" label="Título" sortable>{{
            props.row.title
          }}</b-table-column>
          <b-table-column field="dailyAmount" label="Limite Diário" sortable>{{
            props.row.dailyAmount || '' | money
          }}</b-table-column>
          <b-table-column field="weeklyAmount" label="Limite Semanal" sortable>{{
            props.row.weeklyAmount || '' | money
          }}</b-table-column>
          <b-table-column field="monthlyAmount" label="Limite Mensal" sortable>{{
            props.row.monthlyAmount || '' | money
          }}</b-table-column>



        </template>
        <template slot="empty">
          <section v-if="!isLoading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="sad-tear" size="is-large"></b-icon>
              </p>
              <p>Nenhuma restrição ainda.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import ZHeader from "@/layout/Header";
import restrictions from "@/services/restrictions";
import '../../filters/money';

import "@/filters/registration-plate";

export default {
  data() {
    return {
      title: "Grupos de restrições",
      actions: [
        {
          label: "Novo grupo",
          route: "restricoes/novo",
          class: "is-primary"
        }
      ],
      data: [],
      isLoading: false,
      firstLoad: true
    };
  },
  mounted() {
    this.loadData();
    this.setFilterList();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      restrictions.all().then(data => {
        this.data = data;
        this.isLoading = false;
      });
    },
    view(data) {
      this.$router.push(`restricoes/${data.id}`);
    },

    rowClass() {
      return "is-clickable";
    },
    setFilterList() {},
    filterData() {}
  },
  components: {
    ZHeader
  }
};
</script>

<style lang="scss"></style>
